import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  FUNC_DEFAULT,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import { paragraph500Mixin } from 'styles';

const ConfirmCloseFormPIIPopup = ({
  isOpen,
  onClose,
  onClick,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();

  const renderContentMessage = () => {
    return (
      <SubText
        dangerouslySetInnerHTML={{
          __html: t('popup_confirm_close_form_pii_desc'),
        }}
      />
    );
  };
  const renderBodyContent = () => {
    return (
      <>
        <ImageWrap>
          <img
            src={NoticeIcon}
            alt=""
            width={isDesktop ? '75px' : '75px'}
            height={isDesktop ? '60px' : '60px'}
          />
        </ImageWrap>
        <SizeBox height={isDesktop ? 10 : 16} />
        {renderContentMessage()}
        <SizeBox height={isDesktop ? 24 : 40} />
      </>
    );
  };

  const renderActionButton1 = (width) => (
    <ButtonCommon
      value={t('button_confirm')}
      onClick={onClose}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      color="var(--ds-c-blue)"
      background="var(--ds-c-white)"
    />
  );
  const renderActionButton2 = (width) => (
    <ButtonCommon
      value={t('button_back')}
      color="var(--c-primary)"
      background="var(--bg-primary)"
      isFill={true}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      onClick={onClick}
      isUseKeyDown
    />
  );
  const renderActionButtons = () => {
    return (
      <>
        {renderActionButton1('50%')}
        {renderActionButton2('50%')}
      </>
    );
  };

  return (
    <>
      <style>
        {zIndexModal &&
          `
          .confirm-close-form-pii-modal {
            z-index: ${zIndexModal || '1101'};
          }
        `}
        {isBackdropOverlap
          ? `
          .confirm-close-form-pii-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || '1100'}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .confirm-close-form-pii-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={FUNC_DEFAULT}
        aria-labelledby="contained-modal-title-vcenter"
        className="confirm-close-form-pii-modal"
        backdropClassName="confirm-close-form-pii-modal-backdrop"
        centered
      >
        <ModalBody>{renderBodyContent()}</ModalBody>
        <ModalFooter>{renderActionButtons()}</ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  & .modal-dialog {
    transform: none;
    & .modal-content {
      padding: 16px;
      border-radius: 8px;
      box-shadow: var(--ds-bs-4);
      background: var(--ds-c-white);
      width: 100%;
      height: fit-content;
      margin-inline: auto;
      border: none;
    }
  }

  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    padding: 16px !important;
    & .modal-dialog {
      margin: 0;
      margin-inline: auto;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-right: 0px !important;
    & .modal-dialog {
      & .modal-content {
        width: 436px;
      }
    }
  }
`;

const ModalBody = styled(Modal.Body)`
  padding: 0;
  text-align: left;
`;
const ImageWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const SubText = styled.p`
  ${paragraph500Mixin};
  text-align: center;
  white-space: break-spaces;
  color: var(--ds-c-grey-dark);
  margin: 0;

  & a {
    text-decoration: none;
    color: var(--ds-c-blue-hyperlink-default);
  }

  & b {
    color: var(--ds-c-blue-hyperlink-default);
  }
`;

const ModalFooter = styled(Modal.Footer)`
  border: none;
  padding: 0;
  display: flex;
`;

export default ConfirmCloseFormPIIPopup;
